
import React, { useState, useEffect } from 'react';

import ButtonPopup from '../../Components/common/ButtonPopup';
import ContactAdultCountPop from './ContactAdultCountPop';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Button from '../../Components/common/Button';
import DatePicker from '../../Components/UserComponents/datePicker';
import axios from 'axios';
import { apiMainUser } from '../../utils/constant';
import { useNavigate } from 'react-router-dom';


const ContactDestionationPop = (props) => {
  const [minDateState, setMinDate] = useState();
  const [maxDateState, setMaxDate] = useState();

  console.log(props.propertyId,'cehckPropertyId')

  const navigate = useNavigate();


  const [totalGuestCount, setTotalGuestCount] = useState(1); // Default to 1 adult

  const [guestCount, setGuestCount] = useState(null);
  const [infantCount, setInfantCount] = useState(null);
  const [childrenCount, setChildrenCount] = useState(null);
  const [adultCount, setAdultCount] = useState(null);


  const [selectedCheckIn, setCheckIn] = useState(null); // initialize with the current date or any valid date
const [selectedCheckOut, setCheckOut] = useState(null); // initialize with the current date or any valid date

  const onDateChange = (checkIn, checkOut) => {
    setCheckIn(checkIn?.format("YYYY-MM-DD"));
    setCheckOut(checkOut?.format("YYYY-MM-DD"));
  };


  const ContactHostFunc = () => {
    if (selectedCheckIn && selectedCheckOut && totalGuestCount) {
      const apiUrl = 'create_chat';
  
      // Construct the payload
      const payload = {
        property_id: props.propertyId,
        message_type: 'initial',
        message: '',
        checkin_date: selectedCheckIn,
        checkout_date: selectedCheckOut,
        guests: parseInt(totalGuestCount, 10),
      };
  
      // Add the Authorization header
      const headers = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
  
      axios.post(apiMainUser + apiUrl, payload, { headers })
        .then(response => {
          // Handle the response
          if(response.data.status == 'success'){

            props.closeModal();
            navigate('/user-message');
          }
          
     
        })
        .catch(error => {
          // Handle errors
          console.error('Error during API call:', error);
        });
    } else {
      return;
    }
  };
  




  const handleCounts = (adults, children, infants) => {
    const guestlist = adults + children + infants;
    setGuestCount(adults + children);  // Update guestCount state
    setInfantCount(infants);           // Update infantCount state
    setTotalGuestCount(guestlist);
    
    // console.log(infantCount,guestCount,'checkAllCounts')
    // ... other handling logic if needed
  };


  console.log(selectedCheckIn,selectedCheckOut,'checkAllDates')

  return (
    <div className='Mob-destination-guest-box'>
    {/* Reuse the same class from MobHeadDestinationGuest */}
    <p className='your-shared-class' style={{ fontSize: '13px', fontWeight: 600, marginBottom: '0.5rem' }}>When To Contact</p>

    <div className="guest-dropdown">
      {/* Reuse the same class from MobHeadDestinationGuest */}
      <DatePicker
        minDate={minDateState}
        startDate={selectedCheckIn}
        endDate={selectedCheckOut}
        // Additional props as needed
        onDateChange={onDateChange}
      />
    </div>
    <div style={{border:'1px solid #19A6BB'}} className="guest-infant-div">
            <ButtonPopup
            buttonPopup={true}
            saveBtnClass='sav-edit-btn'
            wrapclass ='absolute w-100'
            makeCustom={
            <div className="guest-dropdown">
              <div style={{paddingLeft:'0.7rem'}}>
            <p className="guest-count-text">
         
           {guestCount > 1 ? guestCount + " " +  'Guests' : '1 Guest'} 
           {infantCount && infantCount > 0 ? (infantCount > 1 ? ', '+infantCount+' Infants' : ', 1 Infant') : ''}            
          </p>
          </div>
          <FontAwesomeIcon icon={faAngleDown} className="arrow-icon" />
          </div>
          }
            divContent={
            <ContactAdultCountPop
            handleCounts={handleCounts} 
            // maxGuests={props.max_guests}
           

            />
          }
           />
            </div>

        
            <div className="search-btn-fixed">
             <Button
            onClick={ContactHostFunc}
            btnText='Contact'
            btnclasses='common-next-btn ' /> 
            
             </div>  


    {/* Add any additional states or functionality needed for the contact component */}
    {/* ... */}
  </div>
  );
}

export default ContactDestionationPop;
